import React from 'react';
import Input from '../componenti/input/Simple';

const Certificazione = ({
    text_nato,
    text_cittadino,
    anteprima, 
    inputValues,
    handleOnChange,
    }) => {
    return (
        <>
            <div style={{padding:'20px'}}>DICHIARA</div>
            che nell’anno
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='annoReddito'
            />
            ha percepito il seguente reddito:
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='totReddito'
            />
            {!anteprima ? '(in lettere:' : null}
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='redditoLettere'
            />
            {!anteprima ? ') ' : null}
        </>
        );
    }

export default Certificazione;